import { NavLink, useLocation } from "react-router-dom";
import { Home, MessageSquare, Calendar, User, AlertTriangle } from "lucide-react";

const BottomNav = ({ user }) => {
  const location = useLocation();

  const navItems = [
    { path: "/chat", label: "Chat", icon: MessageSquare },
    { path: "/nearby", label: "Nearby", icon: Home },
    { path: "/emergency", label: "Emergency", icon: AlertTriangle, isEmergency: true },
    { path: "/bookings", label: "Bookings", icon: Calendar },
    { path: "/profile", label: "Profile", icon: User },
  ];

  return (
    <nav className="fixed bottom-4 left-4 right-4 z-50">
      <div className="max-w-md mx-auto bottom-nav rounded-full px-2 py-2 flex items-center justify-around shadow-lg border border-white/40">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-0.5 px-4 py-2 rounded-full transition-all ${
                isActive
                  ? item.isEmergency
                    ? "bg-red-100 text-red-600"
                    : "bg-primary-100 text-primary-600"
                  : item.isEmergency
                  ? "text-red-400 hover:text-red-500"
                  : "text-slate-400 hover:text-slate-600"
              }`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${item.isEmergency && isActive ? "animate-pulse" : ""}`} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
